module.exports = __webpack_public_path__ + "img/login.d2849afa.png";